<template>
  <div @click="share()">
    <p><i><svg-icon name="share"/></i></p>
  </div>
</template>

<script>
import SvgIcon from './SvgIcon';
import { Share } from '@capacitor/share';
  export default {
    components:{
        SvgIcon
    },
    props: {
      title: String,
      text: String,
      url: {
        type: String,
        required: true
      },
      onError: Function,
      onSuccess: Function,
    },
    methods: {
      
      async share() {
        await Share.share({
        title: this.title,
        text: this.text,
        url: this. url,
        dialogTitle: 'Share from Hyreads',
      });
      }
    }
  }
</script>
<style lang="scss" scoped>
div{
  position:relative;
}
     p{
       position: absolute;
       top: -12px;
    //    left:50px;
     }
</style>
